/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { getStoreBuilder } from 'vuex-typex';
import client from '@/client';
import * as models from '@/models';
import * as utils from '@/utils';
const storeBuilder = getStoreBuilder();
const moduleBuilder = storeBuilder.module('graders', {
    graders: {},
});
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export var GradersStore;
(function (GradersStore) {
    const loaders = {
        graders: {},
    };
    // eslint-disable-next-line
    function _getGraders(state) {
        return (assignmentId) => {
            const graders = state.graders[assignmentId];
            if (graders == null) {
                return null;
            }
            else {
                return graders;
            }
        };
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    GradersStore.getGraders = moduleBuilder.read(_getGraders, 'getGraders');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    GradersStore.commitGraders = moduleBuilder.commit(
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    (state, payload) => {
        const { assignmentId, graders } = payload;
        utils.vueSet(state.graders, assignmentId, graders);
    }, 'commitGraders');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    GradersStore.updateGraderState = moduleBuilder.commit(
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    (state, payload) => {
        const { assignmentId, status } = payload;
        const graders = state.graders[assignmentId];
        if (graders != null) {
            state.graders[assignmentId] = graders.map(grader => grader.setStatus(status[grader.userId]));
        }
    }, 'updateGraderState');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    GradersStore.loadGraders = moduleBuilder.dispatch(
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    (context, payload) => {
        const { assignmentId, force = false } = payload;
        if (!force && _getGraders(context.state)(assignmentId) != null) {
            return null;
        }
        if (force || loaders.graders[assignmentId] == null) {
            loaders.graders[assignmentId] = client.assignment
                .getAllGraders({ assignmentId })
                .run()
                .then(response => response.unsafeCoerce())
                .then(({ cgResult }) => {
                utils.vueDelete(loaders.graders, assignmentId);
                let graders;
                if (cgResult == null) {
                    graders = null;
                }
                else {
                    graders = cgResult.map(models.Grader.fromApiServerData);
                }
                GradersStore.commitGraders({
                    assignmentId,
                    graders,
                });
            });
        }
        return loaders.graders[assignmentId];
    }, 'loadGraders');
})(GradersStore || (GradersStore = {}));
